(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Cosmetic only — this never calls preventDefault(). Shopify's own hCaptcha
    // binding needs the real 'submit' event to reach the form untouched, so this
    // just shows a loading state while that happens and the page reloads. The
    // actual success state ("Done!" + checkmark) is rendered by Liquid above,
    // from form.posted_successfully?, so it's correct even with JS off.
    document.addEventListener('submit', function (event) {
      var form = event.target.closest && event.target.closest('.tuuth-newsletter__form');
      if (!form) return;

      var button = form.querySelector('[data-newsletter-button]');
      var buttonLabel = form.querySelector('[data-newsletter-button-label]');
      if (!button || !buttonLabel || button.disabled) return;

      buttonLabel.textContent = button.getAttribute('data-loading-label') || 'Signing up…';
      button.classList.add('is-loading');
      button.disabled = true;

      // Safety net: if something cancels the submission client-side (a failed
      // captcha challenge, the user backing out of it, etc.) the page never
      // reloads, so re-enable the button instead of leaving it stuck.
      window.setTimeout(function () {
        if (button.classList.contains('is-loading')) {
          button.classList.remove('is-loading');
          button.disabled = false;
          buttonLabel.textContent = button.getAttribute('data-original-label') || buttonLabel.textContent;
        }
      }, 8000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
